import { SearchIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

import { Input } from '../../input/input'

export const FilterInput = (props: { value: string; onChange: (value: string) => void; disabled?: boolean }) => {
  return (
    <div className={cn('h-10 border-b p-1', 'relative')}>
      <Input
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        className={cn(
          'h-8 w-full border-none pl-8',
          'focus-visible:bg-white focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-0'
        )}
        disabled={props.disabled}
      />
      <SearchIcon size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
    </div>
  )
}
